/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, TimeService, UNPLACEHOLDER } from '@dm/core';
import { TaskService } from 'app/common/services/task.service';

@Injectable()
export class TaskStrService {
    get now(): Date {
        // 获取设备时间
        return new Date(this.time.currTime * 1e3);
    }

    taskNameText = this.taskService.taskNameText;

    i18nLabel = {
        numberCol: this.i18n.get('common.Number_col'),
        retryBtn: this.i18n.get('common.retry_button'),
        rollbackBtn: this.i18n.get('common.rollback_button1'),
        deleteBtn: this.i18n.get('common.delete_button'),
        taskName: this.i18n.get('common.name_column'),
        object: this.i18n.get('monitor.task_target_label'),
        taskStatus: this.i18n.get('common.status_column'),
        creator: this.i18n.get('monitor.task_creater_label'),
        startTime: this.i18n.get('common.startTime_label'),
        endTime: this.i18n.get('common.endTime_label'),
        duration: this.i18n.get('common.duration_label'),
        stepName: this.i18n.get('common.name_column'),
        stepStatus: this.i18n.get('common.status_column'),
        closeBtn: this.i18n.get('common.close_button'),
        failedDetail: this.i18n.get('monitor.task_viewDetail_title_lable'),
        possibleCause: this.i18n.get('monitor.task_viewDetail_failed_possCauses_lab'),
        suggestion: this.i18n.get('common.suggest_label'),
        retryBtnTip: this.i18n.get('common.taskCenter_task_retry_error_tips'),
        rollbackBtnTip: this.i18n.get('common.taskCenter_task_rollback_error_tips'),
        deleteTip: this.i18n.get('common.taskCenter_task_deleteRunningTask_error_tips'),
        retrynotSupportTip: this.i18n.get('common.taskCenter_task_retrynotSupport_error_tips'),
        vstoreID: this.i18n.get('common.vstoreID_lab'),
        vstoreName: this.i18n.get('common.vstoreName_lab'),
        rescoverySuggestion:this.i18n.get('monitor.alarm_term_rescoverySuggestion_col'),
        nodeLabel: this.i18n.get('common.node_label'),
        descriptionLabel: this.i18n.get('common.description_column'),
    };

    stepNameText = {
        createNewPairsFor3DC: this.i18n.get('monitor.taskCenter_createStandbyRepliPair_value'),
        createCGFor3DC: this.i18n.get('monitor.taskCenter_createStandbyRepliCG_value'),
        addNewPairs2CGFor3DC: this.i18n.get('monitor.taskCenter_addPairtoStandbyRepliCG_value'),
        createStarFor3DC: this.i18n.get('monitor.taskCenter_createDRStar_value'),
        enableStarFor3DC: this.i18n.get('monitor.taskCenter_enableDRStar_value'),

        generatePara: this.i18n.get('monitor.taskCenter_view_taskInitialization_lab'),
        generatePara1: this.i18n.get('monitor.taskCenter_view_taskInitialization1_lab'),
        generatePara2: this.i18n.get('monitor.taskCenter_view_taskInitialization2_lab'),
        createDiskDomain: this.i18n.get('monitor.taskCenter_view_createDiskDomain_lab'),
        checkDiskDomain: this.i18n.get('monitor.taskCenter_view_checkDiskDomain_status_lab'),
        createStoragePoolStep: this.i18n.get('monitor.taskCenter_createStoragePool_value'),
        queryStoragePool: this.i18n.get('monitor.taskCenter_view_getStoragePool_lab'),
        deleteStoragePoolStep: this.i18n.get('monitor.taskCenter_deleteStoragePool_value'),
        deleteDiskDomain: this.i18n.get('monitor.taskCenter_view_deleteDiskDomain_lab'),
        expandStoragePoolStep: this.i18n.get('monitor.taskCenter_expandStoragePool_value'),
        modifyDiskDomain: this.i18n.get('monitor.taskCenter_view_modifyDiskDomain_lab'),
        modifyStoragePool: this.i18n.get('monitor.taskCenter_modifyStoragePool_value'),
        createlungroup: this.i18n.get('monitor.taskCenter_view_createA_lunGroup_lab'),
        createLuns: this.i18n.get('monitor.taskCenter_view_createA_lun_lab'),

        addNewLunstolungroup: this.i18n.get('monitor.taskCenter_view_name_addNewLun_toLunGroup_value'),
        addExistLunstolungroup: this.i18n.get('monitor.taskCenter_view_name_addExistLun_toLunGroup_value'),
        mapLungrouptohostgroup: this.i18n.get('monitor.taskCenter_view_name_mapLunGroup_toHostGroup_value'),
        mapLungrouptohost: this.i18n.get('monitor.taskCenter_view_name_mapLunGroup_toHost_value'),

        createRemoteLunsForRep: this.i18n.get('monitor.taskCenter_view_name_createRemoteLun_forReplication_value'),
        createRemotePGForRep: this.i18n.get('monitor.taskCenter_view_name_createRemotePG_forReplication_value'),
        addRemoteLuns2RemotePGForRep: this.i18n.get('monitor.taskCenter_view_name_addRemoteLun_toRemotePG_value'),
        createNewLunPairsForRep: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inNewLun_value'),
        createReplicationPairsForNewLuns: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inNewLun_value'),
        createCGForRep: this.i18n.get('monitor.taskCenter_view_name_createReplicationCG_value'),
        addExistPairs2CGForRep: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        addLunstoProtectgroup: this.i18n.get('monitor.taskCenter_view_addLun_toPG_title'),
        createRemoteLunsFroRep1: this.i18n.get('monitor.taskCenter_view_name_createRemoteLun_forReplication_value'),

        addRemoteNewLunstoRemotePGForRep1: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toRemotePG_value'),
        createReplicationPairsForNewLuns1: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inNewLun_value'),
        splitReplicationCG1: this.i18n.get('monitor.taskCenter_view_name_splitReplicationCG_value'),
        addPairs2ReplicationCG1: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        synchronizeReplicationCG1: this.i18n.get('monitor.taskCenter_view_name_syncReplicationCG_value'),
        removeLunsFromProtectgroup: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromPG_value'),
        removeRemoteLunsFromRemotePGForRep1: this.i18n.get('monitor.taskCenter_view_name_removeRemoteLun_fromRemotePG_value'),
        removePairsFromReplicationCG1: this.i18n.get('monitor.taskCenter_view_name_removePair_fromReplicationCG_value'),
        addNewRemoteLuns2PGForRep: this.i18n.get('monitor.taskCenter_view_name_addRemoteLun_toRemotePG_value'),
        addRemoteLunsToRemotePGForRep: this.i18n.get('monitor.taskCenter_view_name_addRemoteLun_toRemotePG_value'),
        createReplicationPairsExistLuns: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inExistLun_value'),
        synchronizeReplicationCG: this.i18n.get('monitor.taskCenter_view_name_syncReplicationCG_value'),
        createReplicationPairsExistLuns1: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inExistLun_value'),
        synchronizeReplicationPairs1: this.i18n.get('monitor.taskCenter_view_name_syncReplicationPair_value'),

        // @todo 资料key
        addSnapstolungroup: this.i18n.get('monitor.taskCenter_addSnapshot_toHostGroup_steps'), // 添加快照到LUN组
        addPairsTgtLun2PGForRep: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        addExistPairsTgtLun2PGForRep: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        createExistLunPairsForRep: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inExistLun_value'),
        addNewPairs2CGForRep: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        syncCGForRep: this.i18n.get('monitor.taskCenter_view_name_syncReplicationCG_value'),

        mapLuntohost: this.i18n.get('monitor.taskCenter_mapLUN_toHost_steps'),    // 映射LUN到主机
        mapLuntohostgroup: this.i18n.get('monitor.taskCenter_mapLUN_toHostGroup_steps'), // 映射LUN到主机组

        createprotectgroup: this.i18n.get('monitor.taskCenter_term_name_createLocalPG_value'),
        createRemoteLunsForMetro: this.i18n.get('monitor.taskCenter_view_name_createRemoteLun_forHyperMetroCG_value'),
        createNewLunPairsForMetro: this.i18n.get('monitor.taskCenter_view_name_createHyperMetroPair_inNewLun_value'),
        createExistLunPairsForMetro: this.i18n.get('monitor.taskCenter_view_name_createHyperMetroPair_inManualRemoteLun_value'),
        createRemoteLGForMetro: this.i18n.get('monitor.taskCenter_view_name_createRemoteLunGroup_forHyperMetroCG_value'),
        addNewRemoteLuns2LGForMetro: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toRemoteLunGroup_value'),
        addExistPairsTgtLun2LGForMetro: this.i18n.get('monitor.taskCenter_view_name_addRemoteLun_inHyperMetroPair_toRemoteLunGroup_value'),
        addPairsTgtLun2LGForMetro: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        createRemotePGForMetro: this.i18n.get('monitor.taskCenter_view_name_createRemotePG_forHyperMetroCG_value'),
        addNewRemoteLuns2PGForMetro: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toNewRemotePG_value'),
        addPairsTgtLun2PGForMetro: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        addExistPairsTgtLun2PGForMetro: this.i18n.get('monitor.taskCenter_view_name_addRemoteLun_inHyperMetroPair_toRemotePG_value'),
        createCGForMetro: this.i18n.get('monitor.taskCenter_view_name_createHyperMetroCG_value'),
        stopExistPairsForMetro: this.i18n.get('monitor.taskCenter_term_name_pauseExistHyperMetroPair_value'),
        stopNewPairsForMetro: this.i18n.get('monitor.taskCenter_term_name_pauseNewHyperMetroPair_value'),
        addNewPairs2CGForMetro: this.i18n.get('monitor.taskCenter_view_name_addNewHyperMetroPair_toNewHyperMetroCG_value'),
        addExistPairs2CGForMetro: this.i18n.get('monitor.taskCenter_term_name_addExistHyperMetroPair_toHyperMetroCG_value'),
        pauseCGForMetro: this.i18n.get('monitor.taskCenter_view_name_hyperMetroCG_task_pause_value'),
        syncCGForMetro: this.i18n.get('monitor.taskCenter_view_name_hyperMetroCG_task_sync_value'),
        mapLG2HGForMetro: this.i18n.get('monitor.taskCenter_view_name_mapLocalLunGroup_toLocalHostGroup_value'),
        mapLG2HostForMetro: this.i18n.get('monitor.taskCenter_view_name_mapLocalLunGroup_toLocalHost_value'),
        createRemoteHGsForMetro: this.i18n.get('monitor.taskCenter_view_name_createRemoteHostGroup_value'),
        createRemoteHostsForMetro: this.i18n.get('monitor.taskCenter_view_name_createRemoteHost_value'),
        addRemoteHosts2HGForMetro: this.i18n.get('monitor.taskCenter_view_name_addRemoteHost_toRemoteHostGroup_value'),
        addRemoteFCs2HostForMetro: this.i18n.get('monitor.taskCenter_view_name_addFCInitiator_toRemoteHost_value'),
        addRemoteiSCSIs2HostForMetro: this.i18n.get('monitor.taskCenter_view_name_addiSCSIInitiator_toRemoteHost_value'),
        mapRemoteForMetro: this.i18n.get('monitor.taskCenter_view_name_mapRemoteLunGroup_toRemoteHostOrGroup_value'),

        addLun2Lungroup: this.i18n.get('monitor.taskCenter_term_name_addLocalLun_toLocalLunGroup_value'),
        addLuns2Protectgroup: this.i18n.get('monitor.taskCenter_term_name_addLocalLun_toLocalPG_value'),
        syncNewPairsForMetro: this.i18n.get('monitor.taskCenter_term_name_syncNewHyperMetroPair_value'),
        syncExistPairsForMetro: this.i18n.get('monitor.taskCenter_term_name_syncExistHyperMetroPair_value'),

        removeLunsFromLungroup: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromLocalLunGroup_value'),
        removeRemoteLunsFromLGForMetro: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromRemoteLunGroup_value'),
        removeRemoteLunsFromPGForMetro: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromRemotePG_value'),
        removePairsFromHyperMetroCG: this.i18n.get('monitor.taskCenter_term_name_removeHyperMetroPair_fromHyperMetroCG_value'),

        modifyHostAluaForMetro: this.i18n.get('monitor.taskCenter_term_name_modify_localHostPreferredPath_value'),
        modifyRemoteHostAluaForMetro: this.i18n.get('monitor.taskCenter_term_name_modify_remoteHostPreferredPath_value'),

        // taskCenter_view_name_createRemoteLunGroup_value
        createRemoteLGForRep:  this.i18n.get('monitor.taskCenter_view_name_createRemoteLunGroup_value'),
        addNewRemoteLuns2LGForRep: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toRemoteLunGroup_value'),
        addPairsTgtLun2LGForRep: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        addExistPairsTgtLun2LGForRep: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        splitExistPairsForRep: this.i18n.get('monitor.taskCenter_view_name_splitRemoteReplicationPair_value'),
        splitNewPairsForRep: this.i18n.get('monitor.taskCenter_view_name_splitRemoteReplicationPair_value'),
        splitNewPairsForRep1: this.i18n.get('monitor.taskCenter_view_name_splitRemoteReplicationPair_value'),
        splitNewPairsForRep2: this.i18n.get('monitor.taskCenter_view_name_splitRemoteReplicationPair_value'),
        createRemoteLunsForRep1: this.i18n.get('monitor.taskCenter_view_name_createRemoteLun_forReplication_value'),
        createNewLunPairsForRep1: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inNewLun_value'),
        createExistLunPairsForRep1: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inExistLun_value'),
        synchronizeNewPairsForRep1: this.i18n.get('monitor.taskCenter_view_name_syncReplicationPair_value'),
        addNewRemoteLuns2LGForRep1: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toRemoteLunGroup_value'),
        addPairsTgtLun2LGForRep1: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        addExistPairsTgtLun2LGForRep1: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        addNewRemoteLuns2PGForRep1: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toNewRemotePG_value'),
        addPairsTgtLun2PGForRep1: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        addExistPairsTgtLun2PGForRep1: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        addNewPairs2CGForRep1: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        splitExistPairsForRep1: this.i18n.get('monitor.taskCenter_view_name_splitRemoteReplicationPair_value'),
        addExistPairs2CGForRep1: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        syncCGForRep1: this.i18n.get('monitor.taskCenter_view_name_syncReplicationCG_value'),
        createRemoteLunsForRep2: this.i18n.get('monitor.taskCenter_view_name_createRemoteLun_forReplication_value'),
        createNewLunPairsForRep2:  this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inNewLun_value'),
        createExistLunPairsForRep2: this.i18n.get('monitor.taskCenter_view_name_createReplicationPair_inExistLun_value'),
        synchronizeNewPairsForRep2: this.i18n.get('monitor.taskCenter_view_name_syncReplicationPair_value'),
        addNewRemoteLuns2LGForRep2:  this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toRemoteLunGroup_value'),
        addPairsTgtLun2LGForRep2: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        addExistPairsTgtLun2LGForRep2: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toRemoteLunGroup_value'),
        addNewRemoteLuns2PGForRep2: this.i18n.get('monitor.taskCenter_view_name_addRemoteNewLun_toNewRemotePG_value'),
        addPairsTgtLun2PGForRep2: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        addExistPairsTgtLun2PGForRep2: this.i18n.get('monitor.taskCenter_view_name_addManualRemoteLun_toNewRemotePG_value'),
        addNewPairs2CGForRep2: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        splitExistPairsForRep2:  this.i18n.get('monitor.taskCenter_view_name_splitRemoteReplicationPair_value'),
        addExistPairs2CGForRep2: this.i18n.get('monitor.taskCenter_view_name_addPair_toReplicationCG_value'),
        syncCGForRep2: this.i18n.get('monitor.taskCenter_view_name_syncReplicationCG_value'),
        splitCGForRep2: this.i18n.get('monitor.taskCenter_view_name_splitReplicationCG_value'),
        removeRemoteLunsFromLGForRep1: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromRemoteLunGroup_value'),
        removePairsFromCGForRep1: this.i18n.get('monitor.taskCenter_view_name_removePair_fromReplicationCG_value'),
        removeRemoteLunsFromPGForRep1: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromRemotePG_value'),
        syncPairsForRep1: this.i18n.get('monitor.taskCenter_view_name_syncReplicationPair_value'),
        removeRemoteLunsFromLGForRep2: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromRemoteLunGroup_value'),
        removeRemoteLunsFromPGForRep2: this.i18n.get('monitor.taskCenter_term_name_removeLun_fromRemotePG_value'),
        syncPairsForRep2: this.i18n.get('monitor.taskCenter_view_name_syncReplicationPair_value'),
        removePairsFromCGForRep2: this.i18n.get('monitor.taskCenter_view_name_removePair_fromReplicationCG_value'),


        addLun2CDPSchedule: this.i18n.get('monitor.taskCenter_addLUN_toHyperCDP_steps'), // 增加LUN到HyperCDP计划
        createCDPs: this.i18n.get('monitor.taskCenter_createHyperCDP_steps'), // 创建HyperCDP
        notifyCDPSchedule: this.i18n.get('monitor.taskCenter_notice_hyperCDP_plan_steps'), // 通知HyperCDP计划

        createSnapGroup: this.i18n.get('monitor.taskCenter_create_snapshotCG_steps'), // 创建快照一致性组
        createCDPGroup: this.i18n.get('monitor.taskCenter_createHyperCDPCG_steps'), // 创建CDP一致性组
        addPG2CDPSchedule: this.i18n.get('monitor.taskCenter_addPG_toHyperCDPPlan_steps'), // 增加保护组到HyperCDP计划
        mapLuns2HostForMetro: this.i18n.get('monitor.taskCenter_mapLUN_toHost_withHyperMetro_steps'), // 为双活映射LUN到主机
        mapNewRemoteLuns2HostForMetro: this.i18n.get('monitor.taskCenter_mapNewRemoteLUN_toHost_withHyperMetro_steps'), // 为双活映射新建远端LUN到主机
        mapPairsTgtLuns2HostForMetro: this.i18n.get('monitor.taskCenter_mapPairTarget_toHost_withHyperMetro_steps'), // 为双活映射Pair目标LUN到主机【映射新建双活pair的目标LUN到主机】
        mapExistPairsTgtLuns2HostForMetro: this.i18n.get('monitor.taskCenter_mapExsistPairTarget_toHost_withHyperMetro_steps'), // 为双活映射已存在Pair的目标LUN到主机【映射已存在双活pair的目标LUN到主机】
        createSnaps: this.i18n.get('monitor.taskCenter_create_snapshot_steps'), // 创建快照
        createNewLunsPairsForRep: this.i18n.get('monitor.taskCenter_newLUN_create_pair_steps'), // 为远程复制新建LUN创建Pair
        syncPairsForRep: this.i18n.get('monitor.taskCenter_view_name_syncReplicationPair_value'), // 同步远程复制Pair
        syncPairsForMetro: this.i18n.get('monitor.taskCenter_view_name_sync_hyperMetroPair_value'), // 同步双活Pair
        splitCGForRep1: this.i18n.get('monitor.taskCenter_view_name_splitReplicationCG_value'), // 分裂远程复制一致性组
        createRemoteNewPGForRep: this.i18n.get('monitor.taskCenter_view_name_createRemotePG_forReplication_value'), // 为远程复制创建远端保护组
        addRemoteLuns2RemoteNewPGForRep: this.i18n.get('monitor.taskCenter_addRemoteLUN_toNewRemotePG_steps'), // 增加远端LUN到新创建的远端保护组
        addRemoteLuns2RemoteNewPGForMetro: this.i18n.get('monitor.taskCenter_addRemoteLUN_toNewRemotePG_steps'), // 增加远端LUN到新创建的远端保护组
        addLuns2NewProtectgroup: this.i18n.get('monitor.taskCenter_addLUN_toNewPG_steps'), // 增加LUN到新创建的保护组
        deleteCGForRep1: this.i18n.get('monitor.taskCenter_deleteReplicationCG_value'), // 删除远程复制一致性组
        deleteCGForRep2: this.i18n.get('monitor.taskCenter_deleteReplicationCG_steps'), // 删除远程复制一致性组
        deleteRemotePGForRep1: this.i18n.get('monitor.taskCenter_deleteRemotePG_withReplication_steps'), // 删除远程复制远端保护组
        deleteRemotePGForRep2: this.i18n.get('monitor.taskCenter_deleteRemotePG_withReplication_steps'), // 删除远程复制的远端保护组
        deleteCGForMetro: this.i18n.get('monitor.taskCenter_delete_hyperMetroCG_steps'), // 删除双活一致性组
        deleteRemotePGForMetro: this.i18n.get('monitor.taskCenter_delete_hyperMetroRemotePG_steps'), // 删除双活的远端保护组

        addCloneToLunGroup: this.i18n.get('monitor.taskCenter_addCloneCGTargetLUN_toLUNCG_steps'),
        createProtectGroup: this.i18n.get('monitor.taskCenter_createProtectionGroup_steps'),
        addLunToProtectGroup: this.i18n.get('monitor.taskCenter_addLunToProtectGroup_steps'),
        splitHyperMetro: this.i18n.get('monitor.taskCenter_splitHyperMetro_steps'),
        splitReplication: this.i18n.get('monitor.taskCenter_splitReplication_steps'),
        createNewClonePair: this.i18n.get('monitor.taskCenter_createClonePair_steps'),
        createExistClonePair: this.i18n.get('monitor.taskCenter_createClonePair_steps'),
        stopSyncClonePair: this.i18n.get('monitor.taskCenter_stopSyncClonePair_steps'),
        addClonePair2CloneGroup: this.i18n.get('monitor.taskCenter_addClonePairtoCloneGroup_steps'),
        removeClonePairFromCloneGroup: this.i18n.get('monitor.taskCenter_removeClonePairFromCloneGroup_steps'),
        syncCloneGroup: this.i18n.get('monitor.taskCenter_syncCloneGroup_steps'),
        reverseSyncCloneGroup: this.i18n.get('monitor.taskCenter_reverseSyncCloneGroup_steps'),
    };

    statusText = {
        wait: this.i18n.get('monitor.task_status_result_waiting'),
        executing: this.i18n.get('monitor.task_status_result_running'),
        success: this.i18n.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_SUCCESS'),
        fail: this.i18n.get('common.downloadFailed_label'),
        rollback_success: this.i18n.get('monitor.task_status_result_rollbackSuccess'),
        rollback_fail: this.i18n.get('monitor.task_status_result_rollbackFail'),
        rollback: this.i18n.get('monitor.task_status_result_rollbacking'),
        partial_fail: this.i18n.get('monitor.task_status_result_partSucceed'),
    };

    color = {
        success: '#3DCCA6',
        failed: '#ff4c4c',
        running: '#3DCCA6',
        partial: '#FF9A52',
    };

    statusColor = {
        wait: this.color.running,
        executing: this.color.running,
        success: this.color.success,
        fail: this.color.failed,
        rollback_success: this.color.success,
        rollback_fail: this.color.failed,
        rollback: this.color.running,
        partial_fail: this.color.partial,
    };

    icon = {
        wait: '#icon-loading',
        executing: '#icon-loading',
        success: '#icon-status-succeed',
        fail: '#icon-status-failed',
        rollback_success: '#icon-status-succeed',
        rollback_fail: '#icon-status-failed',
        rollback: '#icon-loading',
        partial_fail: '',
    };

    secStr = this.i18n.get('common.second_short_label');
    minStr = this.i18n.get('common.min_short_label');
    hourStr = this.i18n.get('common.hour_short_label');

    retryTip = this.i18n.get('monitor.taskCenter_task_retry_msg');
    rollbackTip = this.i18n.get('monitor.taskCenter_task_rollback_tip');
    deleteTip = this.i18n.get('monitor.taskCenter_task_delete_tip');
    deleteTask = this.i18n.get('monitor.taskCenter_task_delete_title_lab');
    deleteTaskWithColon = this.i18n.get('rest.deletetask_msg1', true);
    rollbackTask = this.i18n.get('monitor.taskCenter_task_rollback_title_lab');
    rollbackTaskWithColon = this.i18n.get('monitor.taskCenter_task_rollback_title_lab', true);
    retryTask = this.i18n.get('monitor.taskCenter_task_retry_title_lab');
    retryTaskWithColon = this.i18n.get('monitor.taskCenter_task_retry_title_lab', true);

    AllValue = this.i18n.get('common.all_value');

    taskStatusOptions: { [key: string]: string | number };
    taskNameOptions: { [key: string]: string | number };
    stepNameOptions: { [key: string]: string | number };

    constructor(
        private time: TimeService,
        private i18n: I18nService,
        private taskService: TaskService,
    ) {
        this.taskStatusOptions = this.statusText;
        this.taskNameOptions = this.taskNameText;
        this.stepNameOptions = this.stepNameText;
    }

    // 删除lable
    deleteTaskLable(name: string): string {
        return this.i18n.get('rest.deletetask_msg1', [name]);
    }

    // 生成子步骤失败的国际化标题
    stepFailedTitle(name: string): string {
        return this.i18n.get('common.rest_fail_label', [name]);
    }

    preCheckStepFailedTitle(name: string): string {
        return this.i18n.get('common.rest_reason_label', [name]);
    }

    // 重试任务
    retryTaskMsg(name: string): string {
        return this.i18n.get('rest.retryTask_msg1', [name]);
    }

    // 回滚任务
    rollbackTaskMsg(name: string): string {
        return this.i18n.get('rest.rollbackTask_msg1', [name]);
    }

    // 转换UTC时间戳为带时区信息的字符串
    renderTime(time: number): string {
        return time === 0 ?
            UNPLACEHOLDER :
            this.time.formatUTC(time * 1e3);
    }

    // 渲染持续时间
    renderDuration(duration: number): string {
        // 如果持续时间为NaN或者负数，返回'--'
        if (isNaN(duration) || duration < 0) {
            return UNPLACEHOLDER;
        }

        const isZH = this.i18n.language === 'zh';

        const hourStr = isZH ? this.hourStr : ` ${this.hourStr} `;
        const minStr = isZH ? this.minStr : ` ${this.minStr} `;
        const secStr = isZH ? this.secStr : `${this.secStr}`;

        // 如果持续时间为0，返回'小于1秒'
        if (duration === 0) {
            return `< 1${secStr}`;
        }

        const sec = duration % 60;
        const min = Math.floor(duration / 60) % 60;
        const hour = Math.floor(duration / 3600);

        let result = '';
        result += hour ? hour + hourStr : '';
        result += min ? min + minStr : '';
        result += sec || !result ? sec + secStr : '';

        return result.trim();
    }

    // 计算持续时间
    getDuration(startTime: string, endTime: string): number {
        const now = Math.round(this.now.getTime() / 1000);
        let duration: number;
        if (Number(endTime)) {
            duration = Number(startTime) ? Number(endTime) - Number(startTime) : NaN;
        } else {
            duration = Number(startTime) ? now - Number(startTime) : NaN;
        }

        return duration;
    }
}
